import { render, staticRenderFns } from "./UpdateRole.vue?vue&type=template&id=5b1c2128&scoped=true&"
import script from "./UpdateRole.vue?vue&type=script&lang=js&"
export * from "./UpdateRole.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRole.vue?vue&type=style&index=0&id=5b1c2128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c2128",
  null
  
)

export default component.exports